import { JsonFormsProps } from "@jsonforms/core";
import { createContext } from "react";

export type ValidationError = string | string[];
export type ValidationErrors = Record<string, ValidationError>;

export interface CascadiaJsonFormContextState<Values = any> {
  renderers?: JsonFormsProps["renderers"];
  schema: JsonFormsProps["schema"];
  rootSchema?: JsonFormsProps["schema"];
  setValues(values: Values): void;
  uischema?: JsonFormsProps["uischema"];
  values?: Values;
  rootValues?: Values;
  parentValues?: object;
  initialValues?: Values;
  touched?: Record<string, boolean>;
  setTouched(path: string): unknown;
  setFieldErrors(path: string, errors: string[]): void;
  fieldErrors: Record<string, string[]>;
  submitErrors: ValidationErrors;
  setSubmitErrors(errors: ValidationErrors): void;
  submit(e?: React.FormEvent<HTMLFormElement>): void;
  isSummary?: boolean;
  isSummaryForPath?: (path?: string) => boolean;
  setIsSummaryOverride?(path: string, isSummary: boolean): void;
  isSubmitted?: boolean;
  isSubmitting?: boolean;
  setIsSubmitted?(isSubmitted: boolean): void;
  readonly?: boolean;
  formID?: string;
  locale?: string;
  parent?: CascadiaJsonFormContextState;
  isCheckResults?: boolean;
}

export const CascadiaJsonFormContext =
  createContext<CascadiaJsonFormContextState>({
    schema: undefined!,
    setValues: () => {},
    setTouched: () => {},
    setFieldErrors: () => {},
    submit: () => {},
    fieldErrors: {},
    submitErrors: {},
    setSubmitErrors: () => {},
    isSubmitted: false,
    setIsSubmitted: () => {},
  });
